module.exports = __webpack_public_path__ + "img/pfc.6dadf933.jpg";